const LookupTableConstants = {
  MAX_COLS: 4,
  MIN_COLS: 2,
  MIN_ROWS: 2,
  blankLookupColumnValue: " ",
  blankFormulaDataValue: "",
};
export default LookupTableConstants;
